// Turns three plain answers into a suggested starting point.
//
// Rules live in the pricing config, not in here, so CASS can change what is
// suggested without a developer. Nothing in this file prices anything or waives a
// rule: it only pre-ticks services the visitor is then free to change.

// A rule applies when every answer it names matches one of its accepted values.
// A multi-select answer arrives as an array, so any overlap counts as a match.
const matches = (answer, accepted = []) =>
  Array.isArray(answer) ? answer.some((a) => accepted.includes(a)) : accepted.includes(answer);

const applies = (rule, answers) =>
  Object.entries(rule.when || {}).every(([key, accepted]) => matches(answers[key], accepted || []));

/**
 * @returns {{ ids: string[], reasons: Record<string,string> }} suggested services
 * in catalogue order, with the reason to show beside each.
 */
export function recommend(answers, cfg = {}, services = []) {
  const help = cfg.help_me_choose || {};
  const suggested = new Set();
  (help.rules || []).forEach((rule) => {
    if (applies(rule, answers)) (rule.add || []).forEach((id) => suggested.add(id));
  });

  // Only ever suggest something the website actually offers today, so a service
  // withdrawn in the admin can never be recommended.
  const offered = new Set(services.map((s) => s.service_id));
  const ids = services.filter((s) => suggested.has(s.service_id) && offered.has(s.service_id)).map((s) => s.service_id);

  return { ids, reasons: help.reasons || {} };
}

export const helpQuestions = (cfg = {}) => (cfg.help_me_choose || {}).questions || [];
export const helpEnabled = (cfg = {}) =>
  Boolean((cfg.help_me_choose || {}).enabled && helpQuestions(cfg).length > 0);
